import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69716aa51beda800149029b8/jambo_corporate/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69716aa51beda800149029b8/jambo_corporate/src/styles/index.css");
